import { onEvent } from '../util/domutils';

const SELECTORS = {
  NAVIGATION_ITEM: '.nav-menu__item, .d-inline-block[class*="nav-menu__item--item-"], .nav-menu__item-link--level-1',
  NAVIGATION_ITEM_L1: '.nav-menu__item-link--level-1',
  NAVIGATION_ITEM_L3: '.nav-menu__item-link--level-3',
  MOBILE_ITEM: '.d-inline-block',
};

const EVENT_NAME = 'click_header_nav';
const DATA_LAYER_KEYS = {
  NAVIGATION_CATEGORY: 'navigation_category',
  NAVIGATION_CATEGORY1: 'navigation_category1',
};

/**
 * Traverses up the DOM tree to find the level-1 parent text
 * @param {HTMLElement} element - The clicked level-3 element
 * @returns {string} The text content of the level-1 parent or empty string
 */
const findLevel1Parent = (element) => {
  let currentElement = element;
  for (let i = 0; i < 2; i++) {
    currentElement = currentElement.closest('ul');
    if (!currentElement) return '';
    currentElement = currentElement.closest('li');
    if (!currentElement) return '';
  }

  const level1Link = currentElement.querySelector(SELECTORS.NAVIGATION_ITEM_L1);
  return level1Link ? level1Link.innerText.trim() : '';
};

/**
 * Pushes navigation data to GTM dataLayer
 * @param {string} mainCategory - Main navigation category
 * @param {string|null} subCategory - Optional sub-category
 */
const pushToDataLayer = (mainCategory, subCategory = null) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: EVENT_NAME,
    [DATA_LAYER_KEYS.NAVIGATION_CATEGORY]: mainCategory,
    [DATA_LAYER_KEYS.NAVIGATION_CATEGORY1]: subCategory,
  });
};

/**
 * Handles navigation click events
 * @param {HTMLElement} delegateTarget - The clicked navigation element
 */
const handleNavigationClick = async (delegateTarget, event) => {
  event.stopPropagation();

  if (delegateTarget.matches(SELECTORS.NAVIGATION_ITEM_L1)) {
    pushToDataLayer(delegateTarget.innerText.trim());
    return;
  }

  const clickedLink = delegateTarget.querySelector('a');
  if (!clickedLink) return;

  if (clickedLink.matches(SELECTORS.NAVIGATION_ITEM_L3)) {
    const mainCategory = findLevel1Parent(clickedLink);
    const subCategory = clickedLink.innerText.trim();
    if (mainCategory) {
      pushToDataLayer(mainCategory, subCategory);
    }
  } else if (delegateTarget.matches(SELECTORS.MOBILE_ITEM)) {
    pushToDataLayer(clickedLink.innerText.trim());
  }
};

export default () => {
  onEvent(document, 'click', SELECTORS.NAVIGATION_ITEM, async (e) => {
    handleNavigationClick(e.delegateTarget, e);
  });
};
